import { useAudioTranscription } from "@/hooks/transcriber/useAudioTranscription";
import { useAudioTranscriptionDisabled } from "@/hooks/transcriber/useAudioTranscriptionDisabled";
import type { AudioRecoveryReason } from "./types";

export interface IUseAudioTranscription {
  setStream: (stream: MediaStream) => void;
  audioStream: MediaStream | null;
  transcription: string;
  finished: boolean;
  reset: () => void;
  finishSession: () => void;
  pauseStream: () => void;
  isProviderReady: boolean;
  requiresAudioRecovery: boolean;
  /** Set together with requiresAudioRecovery. */
  audioRecoveryReason: AudioRecoveryReason | null;
  recoverAudio: () => void;
  /**
   * The connection was lost while recording: the live transcript is paused
   * and reconnecting. The recording itself carries on.
   */
  liveTranscriptPaused: boolean;
}

export const getAudioTranscriptionHook = (
  type: boolean,
): (() => IUseAudioTranscription) => {
  switch (type) {
    case true:
      return useAudioTranscription;
    case false:
    default:
      return useAudioTranscriptionDisabled;
  }
};
